import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=e9932492&scoped=true"
import script from "./JobDetail.vue?vue&type=script&lang=js"
export * from "./JobDetail.vue?vue&type=script&lang=js"
import style0 from "./JobDetail.vue?vue&type=style&index=0&id=e9932492&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9932492",
  null
  
)

export default component.exports